import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import { AppBar, Toolbar, Typography, Button, IconButton, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { usePermissions } from '../../hooks/permissions/usePermissions';
import { useSystem } from '../../hooks/api/config';

interface LayoutAppBarProps {
  user: any;
  isMobile: boolean;
  onMenuClick: () => void;
  onLogout: () => void;
}

export const LayoutAppBar: React.FC<LayoutAppBarProps> = ({
  user,
  isMobile,
  onMenuClick,
  onLogout
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { system } = useSystem();
  const { can } = usePermissions();

  const handleSystemSettings = () => {
    navigate('/system-management');
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        {isMobile && (
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* System Name with optional custom branding */}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" component="div">
            {system?.name || 'SmartDoc'}
          </Typography>

          {/* Show system badge for non-mobile */}
          {!isMobile && system?.description && (
            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                px: 1,
                py: 0.25,
                borderRadius: 1,
                fontSize: '0.75rem'
              }}
            >
              {system.description}
            </Typography>
          )}
        </Box>

        {/* Admin System Settings Button */}
        {can.configureChatModels && !isMobile && (
          <IconButton
            color="inherit"
            onClick={handleSystemSettings}
            sx={{ mr: 1 }}
            title={t('system.settings')}
          >
            <SettingsIcon />
          </IconButton>
        )}
        
        {/* Logout Button */}
        {!isMobile && (
          <Button color="inherit" onClick={onLogout}>
            {t('user.logout')}
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};